import { ssoCodeExchange } from '@constants/endpoints';
import { AuthApisPayloads } from '@utils/types';
import { axiosInstance, ssoAxiosInstance } from '.';

export const sendOtpApi = async (
  data: Pick<AuthApisPayloads, 'phoneNo'>,
): Promise<boolean> => {
  const res = await axiosInstance.post('/v1/auth/send-otp', data);
  return !!res.data;
};

export const verifyOtpApi = async (
  verifyOtpApiPayload: AuthApisPayloads,
): Promise<string> => {
  const { data: verifyOtpData } = await axiosInstance.post(
    '/v1/auth/verify-otp',
    verifyOtpApiPayload,
  );

  return verifyOtpData?.data?.token;
};

export const generateNewTokenApi = async (
  loungeId: string,
): Promise<string> => {
  const { data } = await axiosInstance.post('/v1/auth/regenerate-token', {
    loungeId,
  });

  return data.data?.token;
};

export const exchangeSsoCodeApi = async (code: string): Promise<string> => {
  const { data } = await ssoAxiosInstance.post(ssoCodeExchange, { code });

  return data.data?.token;
};
